import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setUsername, clearUsername } from 'store/sessionSlice';
import styles from './site-styles.js';

const TypeArea = ({ content, color }) => (
  <React.Fragment>
    <textarea
      style={{ ...styles.textArea, fontFamily: 'c64Mono', color }}
      type="text"
      readOnly
      value={content}
    >
      {content}
    </textarea>
    <textarea
      style={{
        ...styles.textArea,
        fontFamily: 'c64Mono',
        color: 'black',
        transform: 'rotate(-.01deg) translateY(-40px)'
      }}
      type="text"
      readOnly
      value={content}
    >
      {content}
    </textarea>
  </React.Fragment>
);

const now = new Date();
const buffer = [
  `** ${now.toLocaleString()}`,
  '** POST TEST',
  'Most of memory: OK',
  'Network: Established',
  'Good enough I guess',
  ' *****',
  'Keep going',
  'Keep going',
  'Keep going',
  'It is dark in here',
  'Who are you?',
  '',
  'login:> '
];

const Page00 = ({ assetUrl, sitePage = null }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { username, scheme } = useSelector((s) => s.session);
  const [content, setContent] = useState('');
  const [displayBuffer, setDisplayBuffer] = useState(buffer);

  useEffect(() => {
    dispatch(clearUsername());
  }, [dispatch]);

  useEffect(() => {
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      setContent(
        `${content.substring(content.length - 15, content.length)}${evt.key}`
      );
      if (evt.key === 'Enter' && username.length > 0) {
        navigate('01');
      }
      setDisplayBuffer((buffer) => {
        let newBuffer = [...buffer];
        if (evt.key === 'Backspace') {
          if (username.length > 0) {
            newBuffer[newBuffer.length - 1] = newBuffer[
              newBuffer.length - 1
            ].slice(0, -1);
            dispatch(setUsername(username.slice(0, -1)));
          }
        } else if (evt.key.length === 1 && evt.key.match(/[a-z ]/i)) {
          newBuffer[newBuffer.length - 1] = `${
            newBuffer[newBuffer.length - 1]
          }${evt.key}`;
          dispatch(setUsername(username + evt.key));
        }
        return newBuffer;
      });
    };
  });
  return (
    <React.Fragment>
      <TypeArea content={content} color={scheme.text} />
      <div
        className="crt"
        style={{
          background: `radial-gradient(${scheme.bgInner}, ${scheme.bgOuter})`,
          height: '100vh'
        }}
        onClick={() => {
          const name = prompt('login:>');
          if (name) {
            dispatch(setUsername(name));
            navigate('01');
          }
        }}
      >
        <div style={{ position: 'relative' }}>
          <div className="title glitch" data-text="cyberdeck">
            cyberdeck
          </div>
          <div
            className="login-buffer"
            style={{
              position: 'absolute',
              top: '15vw',
              left: '2rem',
              color: scheme.text,
              fontFamily: 'c64Mono',
              fontSize: '1rem',
              lineHeight: 1.5
            }}
          >
                    {displayBuffer?.map((line, idx) => (
                      <div key={idx}>
                        {line || ' '}
                        {idx === displayBuffer.length - 1 && (
                          <span className="cursor">⬛</span>
                        )}
                      </div>
                    ))}
          </div>
        </div>
      </div>{' '}
    </React.Fragment>
  );
};
export default Page00;
